module.exports = __webpack_public_path__ + "img/img_yinying@2x.7a6a559a.png";